import { PRESTACAO_CONTAS, UPLOAD_ROUTE } from "../constants/apiRoutes";
import api from "./api";

export default {
	findAll(filter) {
		return api.post(PRESTACAO_CONTAS.FIND_ALL_FILTRO, filter);
	},

	findByOcorrenciaId(id) {
		return api.get(PRESTACAO_CONTAS.FIND_ID_OCORRENCIA.replace("{id}", id));
	},

	findBySearch(filter) {
		if (!filter.pagina) {
			filter.pagina = 0;
		}

		return api.post(PRESTACAO_CONTAS.FIND_ALL_FILTRO, filter);
	},

	findHistoricoDacaById(id) {
		return api.get(PRESTACAO_CONTAS.FIND_HISTORICO_ID.replace("{id}", id));
	},

	finalizarPrestacaoConta(prestacaoConta) {
		return api.post(PRESTACAO_CONTAS.FINALIZAR, prestacaoConta);
	},

	async uploadDocumento(analise, documento) {
		const cloneAnalise = {
			...analise
		};

		const dataForm = new FormData();
		dataForm.append("arquivo", documento[0].file);

		const { data } = await api.post(UPLOAD_ROUTE.UPLOAD_ARQUIVO, dataForm);
		cloneAnalise.fileField = documento;
		cloneAnalise.documento = data.data;

		return cloneAnalise;
	},

	findPrestacaoContaById(id) {
		return api.get(PRESTACAO_CONTAS.FIND_ID.replace("{id}", id));
	},

	countPrestacaoContas() {
		return api.get(PRESTACAO_CONTAS.COUNT);
	},

	findByOcorrenciaInfoStatus(id) {
		return api.get(
			PRESTACAO_CONTAS.OCORRENCIA_INFO_STATUS.replace("{id}", id)
		);
	},

	findAllStatusPrestacaoContas() {
		return api.get(PRESTACAO_CONTAS.STATUS);
	},

	findAllLocalProcesso() {
		return api.get(PRESTACAO_CONTAS.LOCAL_PROCESSO);
	},

	findAllForma() {
		return api.get(PRESTACAO_CONTAS.FIND_ALL_FORMA);
	}
};
